export default __webpack_public_path__ + "static/media/sample_1.19efd179.png";